module.exports = __webpack_public_path__ + "img/feed_pin.6c908168.svg";